import { get, post } from './http.js'

// 用户信息、签约、入职
export const getUserInfo = (params) => post('/unicom/cluster/user/getUserInfo', params)
export const saveUserSignInfo = (params) => post('/unicom/cluster/user/saveUserSignInfo', params)
// config 可传 { silent: true } 跳过全局 loading（用于结果轮询）
export const getSignResult = (params, config) => post('/unicom/cluster/user/getSignResult', params, config)
export const entry = (params) => post('/unicom/cluster/user/entry', params)
export const marketCreate = (params) => post('/unicom/cluster/user/marketCreate', params)
export const xlSign = (params) => post('/unicom/cluster/user/xlSign', params)
export const editUser = (params) => post('/unicom/cluster/manager/editUser', params)

// 场景照片提交/更新（url 由 uploadScenePhoto 返回）
export const scenePhotoSubmit = (params) => post('/unicom/cluster/user/scenePhotoSubmit', params)

// 从业资格证照片提交/更新（url 由 uploadSingleFile 返回）
// 接口文档 3.2：重复提交替换原照片，不经营销证审核，不创建支付订单
export const cyzgPicSubmit = (params) => post('/unicom/cluster/user/cyzgPicSubmit', params)

// GN 税务签约（按公司，各启用公司分别签约）
export const listTaxSignConfigs = (params) => post('/unicom/cluster/user/listTaxSignConfigs', params)
export const gnSign = (params) => post('/unicom/cluster/user/gnSign', params)
// config 可传 { silent: true } 跳过全局 loading（用于取链接轮询）
export const getGnSignResult = (params, config) => post('/unicom/cluster/user/getGnSignResult', params, config)

// 磐石转正·劳动关系（员工端）
// config 可传 { raw: true, silent: true } 自行处理业务码（首页探测入口用，兼容无此接口的旧后端）
export const employmentDetail = (params, config) => post('/unicom/cluster/user/employment/detail', params, config)
export const employmentSubmit = (params) => post('/unicom/cluster/user/employment/submit', params)
export const employmentSalaryList = (params) => post('/unicom/cluster/user/employment/salaryList', params)
export const employmentSalaryDetail = (params) => post('/unicom/cluster/user/employment/salaryDetail', params)

// 签转白名单年龄校验（身份证 OCR 成功/切换角色后调用，文档 §14.1）
// config 建议传 { raw: true } 自行读取 data.allowed；请求失败不可按允许处理
export const checkSignAge = (params, config) => post('/unicom/cluster/user/checkSignAge', params, config)

// 服务号消息中心（员工端）
// unread/followStatus 建议传 { raw: true, silent: true }：角标/关注探测自行判断业务码，兼容无此接口的旧后端
export const messageUnread = (params, config) => post('/unicom/cluster/user/message/unread', params, config)
export const messageList = (params) => post('/unicom/cluster/user/message/list', params)
// 查询成功即自动记录首次已读，无需另调 read 接口
export const messageDetail = (params) => post('/unicom/cluster/user/message/detail', params)
export const messageFollowStatus = (params, config) => post('/unicom/cluster/user/message/followStatus', params, config)

// 微信配置（分享签名等）
export const getWxInfo = (params) => get('/unicom/cluster/notify/getWxInfo', params)
